<template>
    <div id="page-integrations">
        <AppBreadCrumb :paths="[{ title: $t('message.integrations') }]" :select="true"></AppBreadCrumb>
        <!-- Navigation Bar -->
        <div class="integration-nav">
            <div class="big-title">{{ $t("message.allIntegrations") }}</div>
            <div class="nav-items">
                <a
                    v-for="(group, index) in integrationGroups"
                    :key="index"
                    :href="'#' + group.id"
                    class="nav-item"
                    :class="{ active: activeGroup === group.id }"
                    @click.prevent="scrollToGroup(group.id)"
                >
                    <span class="material-icons" :style="{ color: group.color }">{{ group.icon }}</span>
                    {{ group.title }}
                </a>
            </div>
        </div>

        <div style="background-color: #ffffff" class="d-flex right-page">
            <div class="pl-3 mt-3" style="flex: 0 0 100%">
                <!-- Social Media -->
                <div class="integration-group" id="social-media">
                    <h3>{{ $t("message.socialMedia") }}</h3>
                    <div class="stories">
                        <div
                            class="story whatsapp-story disabled-integration"
                            v-if="
                                multiWhatsapp &&
                                checkPermission(PERMISSION_TYPES['integrations.whatsapp.view'].tr.name) &&
                                istWhatsappV2()
                            "
                        >
                            <div class="dead-badge">Dead</div>
                            <div class="status" v-if="whatsappV2ChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="compare-button" @click="openWhatsappComparison">
                                <span class="material-icons">compare</span>
                                <span>Kıyasla</span>
                            </div>
                            <div class="img whatsapp">
                                <span class="material-icons star-v2"> star </span>
                                <WhatsappV2 style="width: 40px" />
                            </div>
                            <div class="title">WhatsApp V2 (Web)</div>
                            <div class="description">
                                {{ $t("message.integrationsWhatsappV2") }}
                            </div>
                        </div>
                        <div class="story whatsapp-story" @click="$router.push('integrations/whatsapp-v3')">
                            <div class="status" v-if="whatsappV3ChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="compare-button" @click="openWhatsappComparison">
                                <span class="material-icons">compare</span>
                                <span>Kıyasla</span>
                            </div>
                            <div class="img whatsapp">
                                <WhatsappV3Icon style="width: 40px" />
                            </div>
                            <div class="title">WhatsApp V3 (QR Code)</div>
                            <div class="description">
                                {{ $t("message.integrationsWhatsappV2") }}
                            </div>
                        </div>
                        <div
                            v-if="checkPermission(PERMISSION_TYPES['integrations.whatsapp.view'].tr.name)"
                            class="story whatsapp-story"
                            @click="$router.push('integrations/whatsapp-business-api')"
                        >
                            <div class="status" v-if="whatsappBusinessChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="compare-button" @click="openWhatsappComparison">
                                <span class="material-icons">compare</span>
                                <span>Kıyasla</span>
                            </div>
                            <div class="img whatsapp">
                                <WhatsappBusinessIcon style="width: 50px" />
                            </div>
                            <div class="title">WhatsApp Business API</div>
                            <div class="description">
                                {{ $t("message.integrationsWhatsappBusiness") }}
                            </div>
                        </div>
                         <div
                            v-if="checkPermission(PERMISSION_TYPES['integrations.whatsapp.view'].tr.name)"
                            class="story"
                            @click="$router.push('integrations/waba')"
                        >
                            <div class="status" v-if="whatsappBusinessChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img whatsapp">
                                <WhatsappBusinessIcon style="width: 50px" />
                            </div>
                            <div class="title">WhatsApp Business API v2</div>
                            <div class="description">
                                {{ $t("message.integrationsWhatsappBusiness") }}
                            </div>
                        </div>
                        <div class="story" @click="$router.push('integrations/instagram')">
                            <div class="status" v-if="instagramChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img instagram">
                                <InstagramIcon />
                            </div>
                            <div class="title">Instagram</div>
                            <div class="description">
                                {{ $t("message.integrationsInstagram") }}
                            </div>
                        </div>

                        <div class="story instagram-v2-story" @click="$router.push('integrations/instagram-v2')">
                            <div class="status" v-if="instagramV2ChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img instagram">
                                <InstagramIcon />
                            </div>
                            <div class="title">Instagram V2</div>
                            <div class="description">
                                Instagram Login ile direkt bağlantı. Facebook hesabına gerek yok.
                            </div>
                        </div>

                        <div class="story" @click="$router.push('integrations/messenger')">
                            <div class="status" v-if="messengerChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img messenger">
                                <FacebookIcon />
                            </div>
                            <div class="title">Messenger</div>
                            <div class="description">
                                {{ $t("message.messengerIntegrationDesc") }}
                            </div>
                        </div>
                        <div class="story" @click="$router.push('integrations/linkedin')">
                            <div class="status" v-if="linkedinChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img linkedin">
                                <LinkedinIcon />
                            </div>
                            <div class="title">Linkedin</div>
                            <div class="description">
                                {{ $t("message.integrationsLinkedin") }}
                            </div>
                        </div>
                        <div class="story" @click="$router.push('integrations/telegram-qr')">
                            <div class="status" v-if="telegramChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img telegram">
                                <TelegramIcon />
                            </div>
                            <div class="title">Telegram (QR Code)</div>
                            <div class="description">
                                {{ $t("message.integrationsTelegram") }}
                            </div>
                        </div>

                        <div
                            v-if="checkPermission(PERMISSION_TYPES['integrations.telegram.view'].tr.name)"
                            class="story"
                            @click="
                                () =>
                                    telegramEnabled
                                        ? createTelegramChannel()
                                        : $feature.beforeCreateIntegrationChannel(createTelegramChannel, 'telegram')
                            "
                        >
                            <div class="status" v-if="telegramEnabled">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <a-modal
                                :title="$t('telegram.telegramTokenTitle')"
                                wrapClassName="vertical-center-modal"
                                :visible="integrateTelegramModalVisible"
                                @cancel="handleCancel()"
                                @ok="handleOk()"
                            >
                                <div class="col mb-5">
                                    <a-form-item :label="$t('telegram.typeInTelegramToken')">
                                        <a-modal
                                            v-model="visibleDeleteToken"
                                            :title="$t('telegram.telegramAlertTitle')"
                                            @ok="confirmDeleteToken"
                                            @cancel="cancelDeleteToken"
                                        >
                                            <p>{{ $t("telegram.telegramAlertText") }}</p>
                                        </a-modal>
                                        <div class="row mb-3">
                                            <a-input
                                                style="width: 90%"
                                                autofocus
                                                class="mt-2"
                                                :class="{ 'err-class': showWarning }"
                                                @change="onTelegramTokenChange"
                                                v-model="tempToken"
                                                :placeholder="$t('telegram.token')"
                                            />
                                            <a-button
                                                type="primary"
                                                icon="delete"
                                                v-if="isThereTempToken"
                                                class="ml-2 p-10 mt-2"
                                                @click="showDeleteConfirmation"
                                            ></a-button>
                                        </div>
                                    </a-form-item>

                                    <a-alert show-icon type="info">
                                        <div slot="description">
                                            {{ $t("telegram.telegramAlertForm") }}
                                            <a href="https://t.me/BotFather" target="_blank">BotFather</a>
                                        </div>
                                    </a-alert>
                                </div>
                            </a-modal>
                            <div class="img telegram">
                                <TelegramIcon />
                            </div>
                            <div class="title">Telegram (Bot Father)</div>
                            <div class="description">
                                {{ $t("message.integrationsTelegram") }}
                            </div>
                        </div>
                        <div class="story" @click="$router.push('integrations/youtube-comments')">
                            <div class="status" v-if="youtubeChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img youtube">
                                <YouTubeIcon />
                            </div>
                            <div class="title">YouTube Comments</div>
                            <div class="description">{{ $t("message.integrationsYouTubeComments") }}</div>
                        </div>
                        <div class="story" @click="$router.push('integrations/google-business-reviews')">
                            <div class="status" v-if="googleBusinessChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img google-business">
                                <GoogleBusinessIcon />
                            </div>
                            <div class="title">Google Business Reviews</div>
                            <div class="description">{{ $t("message.integrationsGoogleBusinessReviews") }}</div>
                        </div>
                        <div class="story" @click="$router.push('integrations/google-play-reviews')">
                            <div class="status" v-if="googlePlayChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img google-play">
                                <GooglePlayIcon />
                            </div>
                            <div class="title">Google Play Reviews</div>
                            <div class="description">{{ $t("message.integrationsGooglePlayReviews") }}</div>
                        </div>
                        <div class="story" @click="$router.push('integrations/appstore-reviews')">
                            <div class="status" v-if="appStoreChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img appstore">
                                <AppStoreIcon />
                            </div>
                            <div class="title">App Store Reviews</div>
                            <div class="description">{{ $t("message.integrationsAppStoreReviews") }}</div>
                        </div>

                        <!-- Voting integrations -->
                        <!-- <div class="story voting" @click="castVote('Twitter', $event)">
                            <div class="img twitter">
                                <TwitterIcon />
                            </div>
                            <div class="title">Twitter</div>
                            <div class="description">
                                {{ $t("message.integrateSupsiswithIntegratable", { integratable: "Twitter" }) }}
                            </div>
                        </div>

                        <div class="story voting" @click="castVote('Slack', $event)">
                            <div class="img slack">
                                <SlackIcon />
                            </div>
                            <div class="title">Slack</div>
                            <div class="description">
                                {{ $t("message.integrateSupsiswithIntegratable", { integratable: "Slack" }) }}
                            </div>
                        </div>
                        <div class="story voting" @click="castVote('Skype', $event)">
                            <div class="img skype">
                                <SkypeIcon />
                            </div>
                            <div class="title">Skype</div>
                            <div class="description">
                                {{ $t("message.integrateSupsiswithIntegratable", { integratable: "Skype" }) }}
                            </div>
                        </div> -->
                    </div>
                </div>

                <!-- Web -->
                <div class="integration-group" id="web">
                    <h3>{{ $t("message.web") }}</h3>
                    <div class="stories">
                        <div class="story" @click="$router.push('/integrations/webchat/bubble-settings')">
                            <div class="status">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img supsis">
                                <SupsisIcon />
                            </div>
                            <div class="title">{{ $t("message.chatWidget") }}</div>
                            <div class="description">
                                {{ $t("message.integrationsWebchat") }}
                            </div>
                        </div>
                        <div class="story" @click="$router.push('/integrations/webhook')">
                            <div class="img webhooks">
                                <WebhookIcon />
                            </div>
                            <div class="title">{{ $t("message.webhooks") }}</div>
                            <div class="description">
                                {{ $t("message.integrateSupsiswithIntegratable", { integratable: "Webhooks" }) }} .
                            </div>
                        </div>
                        <div class="story" @click="$router.push('/integrations/webtabs')">
                            <div class="img webtabs">
                                <span class="material-icons">tab</span>
                            </div>
                            <div class="title">Web Sekmeler</div>
                            <div class="description">
                                Sidebar menüye özel sekmeler ekleyerek dış uygulamaları Supsis içinde açın
                            </div>
                        </div>
                        <div class="story" @click="$router.push('/integrations/webapps')">
                            <div class="img webapps">
                                <span class="material-icons">web</span>
                            </div>
                            <div class="title">Web Apps</div>
                            <div class="description">
                                Kendi web uygulamalarınızı yükleyin ve yönetin
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Email -->
                <div class="integration-group" id="email">
                    <h3>{{ $t("message.email") }}</h3>
                    <div class="stories">
                        <div class="story" @click="$router.push('integrations/mail')" v-if="isEmailFeatureEnabled()">
                            <div class="img mail">
                                <DynamicSvg name="Mail" />
                            </div>
                            <div class="title">Mail</div>
                            <div class="description">
                                {{ $t("message.integrateSupsiswithIntegratable", { integratable: "Mail" }) }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- SMS -->
                <div class="integration-group" id="sms">
                    <h3>{{ $t("message.sms") }}</h3>
                    <div class="stories">
                        <div class="story" @click="$router.push('integrations/sms/postacell')">
                            <div class="status" v-if="smsChannels.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img postacell"><img src="/static/img/postacell-logo.png" /></div>
                            <div class="title">SMS - Postacell</div>
                            <div class="description">{{ $t("message.integrationsSMSPostacell") }}</div>
                        </div>
                    </div>
                </div>

                <!-- CRM -->
                <div class="integration-group" id="crm">
                    <h3>{{ $t("message.crm") }}</h3>
                    <div class="stories">
                        <div class="story" @click="$router.push('integrations/bitrix24')">
                            <div class="status" v-if="bitrixChannels.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ideasoft">
                                <BitrixIcon />
                            </div>
                            <div class="title">Bitrix24</div>
                            <div class="description">{{ $t("message.integrationsBitrix24") }}</div>
                        </div>
                        <div class="story" @click="$router.push('integrations/zoho')">
                            <div class="status" v-if="zohoChannels.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ideasoft">
                                <ZohoIcon />
                            </div>
                            <div class="title">Zoho CRM</div>
                            <div class="description">{{ $t("message.integrationsZoho") }}</div>
                        </div>
                        <div class="story" @click="$router.push('integrations/teamgram')">
                            <div class="status" v-if="teamgramChannels.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img teamgram">
                                <TeamGramIcon />
                            </div>
                            <div class="title">Teamgram</div>
                            <div class="description">{{ $t("message.integrationsTeamgram") }}</div>
                        </div>
                    </div>
                </div>

                <!-- E-Commerce -->
                <div class="integration-group" id="e-commerce">
                    <h3>{{ $t("message.ecommerce") }}</h3>
                    <div class="stories">
                        <div class="story" @click="$router.push('integrations/ideasoft')">
                            <div class="status" v-if="ideasoftChannels.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ideasoft">
                                <IdeasoftIcon />
                            </div>
                            <div class="title">Ideasoft</div>
                            <div class="description">{{ $t("message.integrationsIdeasoft") }}</div>
                        </div>
                        <div class="story" @click="$router.push('integrations/ticimax')">
                            <div class="status" v-if="ticimaxChannels.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ticimax">
                                <div class="img postacell"><img src="/static/img/ticimax.png" /></div>
                            </div>
                            <div class="title">Ticimax</div>
                            <div class="description">{{ $t("message.integrationsTicimax") }}</div>
                        </div>
                        <div class="story" @click="$router.push('/integrations/ticimax-v2')">
                            <div class="status" v-if="ticimaxChannelsV2.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ticimax">
                                <div class="img postacell"><img src="/static/img/ticimax.png" /></div>
                            </div>
                            <div class="title">Ticimax-V2</div>
                            <div class="description">Ticimax mağaza bilgilerinizi Supsis üzerinden kolayca yönetmenizi ve müşterilerinize anlık yanıtlar vermenizi sağlar.</div>
                        </div>
                        <div class="story" @click="$router.push('integrations/trendyol')">
                            <div class="status" v-if="trendyolChannelExists.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img">
                                <TrendyolIcon />
                            </div>
                            <div class="title">{{ $t("message.trendyol") }}</div>
                            <div class="description">{{ $t("message.integrationsTrendyol") }}</div>
                        </div>
                        <div class="story" @click="$router.push('integrations/t-soft')">
                            <div class="status" v-if="tsoftChannelExists.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img">
                                <TsoftIcon />
                            </div>
                            <div class="title">T-SOFT</div>
                            <div>
                                T-SOFT Mağzanızı Siparişlerinizi ve kargo durumlarını SUPSIS AI ile kolayca yönetin.
                            </div>
                        </div>
                        <div class="story" @click="$router.push('integrations/ikas')">
                            <div class="status" v-if="ikasChannelExists.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img" style="background: #deff37">
                                <IkasIcon />
                            </div>
                            <div class="title">IKAS</div>
                            <div>
                                Ikas Mağzanızı Siparişlerinizi ve kargo durumlarını SUPSIS AI ile kolayca yönetin.
                            </div>
                        </div>

                        <!-- Voting integrations -->
                        <!-- <div class="story voting" @click="castVote('Shopify', $event)">
                            <div class="img shopify">
                                <ShopifyIcon />
                            </div>
                            <div class="title">Shopify</div>
                            <div class="description">{{ $t("message.integrateSupsiswithIntegratable", { integratable: "Shopify" }) }}</div>
                        </div> -->
                    </div>
                </div>

                <!-- Utilities -->
                <div class="integration-group" id="utilities">
                    <h3>{{ $t("message.utilities") }}</h3>
                    <div class="stories">
                        <div class="story" @click="$router.push('/integrations/webhook')">
                            <div class="img webhooks">
                                <WebhookIcon />
                            </div>
                            <div class="title">{{ $t("message.webhooks") }}</div>
                            <div class="description">
                                {{ $t("message.integrateSupsiswithIntegratable", { integratable: "Webhooks" }) }} .
                            </div>
                        </div>
                        <div class="story" @click="$router.push('/cache-manager')">
                            <div class="img cache">
                                <span class="material-icons">storage</span>
                            </div>
                            <div class="title">{{ $t("Cache Manager") }}</div>
                            <div class="description">
                                Otomasyon ve chatbot'lar arası veri paylaşımı için cache yönetimi
                            </div>
                        </div>
                        <div class="story" @click="$router.push('integrations/openai')">
                            <div class="status" v-if="openaiChannels.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img">
                                <OpenaiIcon />
                            </div>
                            <div class="title">OpenAI</div>
                            <div class="description">
                                <div>{{ $t("message.integrationsOpenAI") }}</div>
                            </div>
                        </div>
                        <div class="story" @click="showSlackIntegration">
                            <div class="status" v-if="slackChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img slack">
                                <SlackIcon />
                            </div>
                            <div class="title">Slack</div>
                            <div class="description">
                                {{ $t("integrations.slackCardDescription") }}
                            </div>
                            <SlackIntegrationModal
                                :modalVisible="slackIntegrationModalVisible"
                                @close="slackIntegrationModalVisible = false"
                            />
                        </div>
                        <div class="story" @click="showPushoverIntegration">
                            <div class="status" v-if="pushoverChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img pushover">
                                <PushoverIcon />
                            </div>
                            <div class="title">Pushover</div>
                            <div class="description">
                                {{ $t("integrations.pushoverCardDescription") }}
                            </div>
                            <PushoverIntegrationModal
                                :modalVisible="pushoverIntegrationModalVisible"
                                @close="pushoverIntegrationModalVisible = false"
                            />
                        </div>
                    </div>
                </div>

                <!-- Advertising -->
                <div class="integration-group" id="advertising">
                    <h3>{{ $t("message.advertising") }}</h3>
                    <div class="stories">
                        <div class="story" @click="$router.push('integrations/meta-leads')">
                            <div class="status" v-if="metaLeadsChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img meta">
                                <MetaIcon />
                            </div>
                            <div class="title">Meta Leads</div>
                            <div class="description">{{ $t("message.integrationsMetaLeads") }}</div>
                        </div>
                      
                    </div>
                </div>

                <!-- Ses -->
                <div class="integration-group" id="ses">
                    <h3>Ses</h3>
                    <div class="stories">
                        <div class="story" @click="$router.push('/integrations/webphone/redsantral')">
                            <div class="status" v-if="webphoneChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img webphone">
                                <span class="material-icons" style="color: #d32f2f">phone</span>
                            </div>
                            <div class="title">Webphone (Kırmızı Santral)</div>
                            <div class="description">Web tabanlı telefon sistemi entegrasyonu</div>
                        </div>
                        <div class="story" @click="$router.push('/integrations/webphone/telnyx')">
                            <div class="status" v-if="telnyxChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img telnyx">
                                <img src="/static/img/telnyx.png" alt="Telnyx" style="width: 40px; height: 40px;" />
                            </div>
                            <div class="title">Webphone (Telnyx)</div>
                            <div class="description">Global arama yapabilmek için Telnyx entegrasyonu</div>
                        </div>
                        <div class="story" @click="$router.push('/integrations/webphone/netgsm')">
                            <div class="status" v-if="netgsmChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img netgsm">
                                <img src="/static/img/netgsm.png" alt="NetGSM" style="width: 40px; height: 40px;" />
                            </div>
                            <div class="title">Webphone (NetGSM)</div>
                            <div class="description">NetGSM santral sistemi ile web tabanlı telefon entegrasyonu</div>
                        </div>
                        <PermissionController :permissions="['voice-agent.get']">
                            <div class="story" @click="$router.push('integrations/voice-agent')">
                                <div class="status" v-if="retellChannelExists">
                                    <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                                </div>
                                <div class="img retell">
                                    <span class="material-icons">record_voice_over</span>
                                </div>
                                <div class="title">AI Voice Agent</div>
                                <div class="description">
                                    Telefonlarınızı sesli yapay zeka asistanı ile yönetin. Ayrıca web sitesinize sesli
                                    asistan entegre edebilirsiniz.
                                </div>
                            </div>
                        </PermissionController>
                    </div>
                </div>
            </div>
        </div>

        <!-- WhatsApp Comparison Modal -->
        <a-modal
            :visible.sync="whatsappComparisonModalVisible"
            :cancel-text="null"
            @ok="() => (whatsappComparisonModalVisible = false)"
            :width="1400"
            :footer="false"
            :footer-hide="true"
            class="custom-modal whatsapp-comparison-modal"
            v-on:cancel="whatsappComparisonModalVisible = false"
            title="WhatsApp Çözümleri Karşılaştırması"
        >
            <WhatsappComparison />
        </a-modal>
    </div>
</template>

<script>
import SideMenuBar from "./Chatbot/SideMenuBar";
import { mapActions, mapGetters, mapState } from "vuex";
import WebhookIcon from "./Chatbot/pages/integrations/svg/WebhookIcon";
import OpenaiIcon from "./Chatbot/pages/integrations/svg/OpenaiIcon";
import SupsisIcon from "./Chatbot/pages/integrations/svg/SupsisIcon";
import WhatsappIcon from "./Chatbot/pages/integrations/svg/WhatsappIcon";
import InstagramIcon from "./Chatbot/pages/integrations/svg/InstagramIcon";
import TelegramIcon from "./Chatbot/pages/integrations/svg/TelegramIcon";
import TwitterIcon from "./Chatbot/pages/integrations/svg/TwitterIcon";
import FacebookIcon from "./Chatbot/pages/integrations/svg/FacebookIcon.vue";
import SkypeIcon from "./Chatbot/pages/integrations/svg/SkypeIcon.vue";
import ShopifyIcon from "../../components/fast-initialize/svg/ShopifyIcon";
import SlackIcon from "./Chatbot/pages/integrations/svg/SlackIcon.vue";
import MaliIcon from "./Chatbot/pages/integrations/svg/MailIcon";
import _ from "lodash";
import { sendSocketMessage } from "../../utils/socketStream";
import log2 from "../../utils/log2";
import WhatsappBusinessIcon from "./Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";
import LinkedinIcon from "./Chatbot/pages/integrations/svg/LinkedinIcon.vue";
import CONFIG from "../../config/config";
import { PERMISSION_TYPES } from "../../language/permissionTypes";
import AppBreadCrumb from "../../components/common/AppBreadCrumb.vue";
import WhatsappV1 from "./Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV1.vue";
import WhatsappV2 from "./Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV2.vue";
import IdeasoftIcon from "./Chatbot/pages/integrations/svg/IdeasoftIcon.vue";
import MessengerIcon from "./Chatbot/pages/integrations/svg/MessengerIcon.vue";
import TeamGramIcon from "./Chatbot/pages/integrations/svg/TeamGramIcon.vue";
import MetaIcon from "./Chatbot/pages/integrations/svg/MetaIcon.vue";
import YouTubeIcon from "./Chatbot/pages/integrations/svg/YouTubeIcon.vue";
import GoogleBusinessIcon from "./Chatbot/pages/integrations/svg/GoogleBusinessIcon.vue";
import GooglePlayIcon from "./Chatbot/pages/integrations/svg/GooglePlayIcon.vue";
import AppStoreIcon from "./Chatbot/pages/integrations/svg/AppStoreIcon.vue";
import BitrixIcon from "./Chatbot/pages/integrations/svg/BitrixIcon.vue";
import TrendyolIcon from "./Chatbot/pages/integrations/svg/TrendyolIcon.vue";
import TsoftIcon from "./Chatbot/pages/integrations/svg/TsoftIcon.vue";
import IkasIcon from "./Chatbot/pages/integrations/svg/IkasIcon.vue";
import ZohoIcon from "./Chatbot/pages/integrations/svg/ZohoIcon.vue";
import WhatsappV3Icon from "./Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV3.vue";
import confetti from "canvas-confetti";
import DynamicSvg from "../../components/DynamicSvg.vue";
import PermissionController from "../../components/permission-controller/PermissionController";
import WhatsappComparison from "../../components/WhatsappComparison.vue";
import PushoverIcon from "./Chatbot/pages/integrations/svg/PushoverIcon.vue";
import PushoverIntegrationModal from "./Chatbot/pages/integrations/components/PushoverIntegrationModal.vue";
import SlackIntegrationModal from "./Chatbot/pages/integrations/components/SlackIntegrationModal.vue";

const log = log2("Integrations");
export default {
    name: "Integrations",
    components: {
        DynamicSvg,
        WhatsappV3Icon,
        ZohoIcon,
        TrendyolIcon,
        TsoftIcon,
        IkasIcon,
        BitrixIcon,
        TeamGramIcon,
        MetaIcon,
        YouTubeIcon,
        GoogleBusinessIcon,
        GooglePlayIcon,
        AppStoreIcon,
        MessengerIcon,
        IdeasoftIcon,
        AppBreadCrumb,
        SlackIcon,
        ShopifyIcon,
        SkypeIcon,
        FacebookIcon,
        TwitterIcon,
        WhatsappIcon,
        InstagramIcon,
        TelegramIcon,
        SupsisIcon,
        SideMenuBar,
        WebhookIcon,
        OpenaiIcon,
        WhatsappBusinessIcon,
        MaliIcon,
        WhatsappV1,
        WhatsappV2,
        LinkedinIcon,
        WhatsappComparison,
        PushoverIcon,
        PushoverIntegrationModal,
        SlackIntegrationModal,
    },
    data() {
        return {
            integrateTelegramModalVisible: false,
            showWarning: false,
            tempToken: "",
            visibleDeleteToken: false,
            handleSaveSetting: _.debounce((newSettings) => {
                this.updateSettings(newSettings);
            }, 100).bind(this),
            multiWhatsapp: CONFIG.MULTI_WHATSAPP.enabled,
            isThereTempToken: false,
            PERMISSION_TYPES,
            activeGroup: "social-media",
            whatsappComparisonModalVisible: false,
            slackIntegrationModalVisible: false,
            pushoverIntegrationModalVisible: false,
            integrationGroups: [
                { id: "social-media", title: this.$t("message.socialMedia"), icon: "share", color: "#ea4335" },
                { id: "web", title: this.$t("message.web"), icon: "language", color: "#4285f4" },
                { id: "email", title: this.$t("message.email"), icon: "email", color: "#fbbc05" },
                { id: "sms", title: this.$t("message.sms"), icon: "sms", color: "#34a853" },
                { id: "crm", title: this.$t("message.crm"), icon: "people", color: "#ff7043" },
                { id: "e-commerce", title: this.$t("message.ecommerce"), icon: "shopping_cart", color: "#9c27b0" },
                { id: "utilities", title: this.$t("message.utilities"), icon: "build", color: "#795548" },
                { id: "advertising", title: this.$t("message.advertising"), icon: "campaign", color: "#607d8b" },
                PermissionController.check(["voice-agent.get"]) && {
                    id: "ses",
                    title: "Ses",
                    icon: "mic",
                    color: "#3f51b5",
                },
            ].filter(Boolean),
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            emailDomain: (state) =>
                state.site.site.alias === "supsis"
                    ? CONFIG.EMAIL_DOMAIN
                    : `${state.site.site.alias}.${CONFIG.EMAIL_DOMAIN}`,
            whatsappV1ChannelExists: (state) => state.channel.channels.some((x) => x.type === "whatsapp-qr"),
            whatsappV2ChannelExists: (state) => state.channel.channels.some((x) => x.type === "whatsapp-v2"),
            whatsappBusinessChannelExists: (state) =>
                state.channel.channels.some((x) => x.type === "whatsapp-business-api" || x.type === "whatsapp-business-api-supsis"),
            linkedinChannelExists: (state) => state.channel.channels.some((x) => x.type === "linkedin-unipile"),
            telegramChannelExists: (state) => state.channel.channels.some((x) => x.type === "telegram-unipile"),
            whatsappV3ChannelExists: (state) => state.channel.channels.some((x) => x.type === "whatsapp-unipile"),
            messengerChannelExists: (state) => state.channel.channels.some((x) => x.type === "messenger"),
            instagramChannelExists: (state) => state.channel.channels.some((x) => x.type === "instagram"),
            instagramV2ChannelExists: (state) => state.channel.channels.some((x) => x.type === "instagram-v2"),
            metaLeadsChannelExists: (state) => state.channel.channels.some((x) => x.type === "meta-leads"),
            youtubeChannelExists: (state) => state.channel.channels.some((x) => x.type === "youtube-comments"),
            googleBusinessChannelExists: (state) => state.channel.channels.some((x) => x.type === "google-business-reviews"),
            googlePlayChannelExists: (state) => state.channel.channels.some((x) => x.type === "google-play-reviews"),
            appStoreChannelExists: (state) => state.channel.channels.some((x) => x.type === "appstore-reviews"),
            smsChannels: (state) => state.channel.channels.filter((x) => x.type === "sms-postacell"),
            openaiChannels: (state) => state.channel.channels.filter((x) => x.type === "openai"),
            ideasoftChannels: (state) => state.channel.channels.filter((x) => x.type === "ideasoft"),
            bitrixChannels: (state) => state.channel.channels.filter((x) => x.type === "bitrix"),
            zohoChannels: (state) => state.channel.channels.filter((x) => x.type === "zoho"),
            ticimaxChannels: (state) => state.channel.channels.filter((x) => x.type === "ticimax"),
            ticimaxChannelsV2: (state) => state.channel.channels.filter((x) =>x.type === "ticimax-v2"),
            teamgramChannels: (state) => state.channel.channels.filter((x) => x.type === "teamgram"),
            holidayPlusChannels: (state) => state.channel.channels.filter((x) => x.type === "holiday-plus"),
            trendyolChannelExists: (state) => state.channel.channels.filter((x) => x.type === "trendyol"),
            tsoftChannelExists: (state) => state.channel.channels.filter((x) => x.type === "t-soft"),
            ikasChannelExists: (state) => state.channel.channels.filter((x) => x.type === "ikas"),
            retellChannelExists: (state) => state.channel.channels.some((x) => x.type === "retell"),
            webphoneChannelExists: (state) => state.channel.channels.some((x) => x.type === "webphone-kirmizisantral"),
            telnyxChannelExists: (state) => state.channel.channels.some((x) => x.type === "webphone-telnyx"),
            netgsmChannelExists: (state) => state.channel.channels.some((x) => x.type === "webphone-netgsm"),
            slackChannelExists: (state) => state.channel.channels.some((x) => x.type === "slack" && x.enabled && !x.isDeleted),
            pushoverChannelExists: (state) => state.channel.channels.some((x) => x.type === "pushover" && x.enabled && !x.isDeleted),
            user: (state) => state.auth.user,
        }),
        ...mapGetters({
            telegramEnabled: "setting/telegramEnabled",
            checkPermission: "auth/checkPermission",
        }),
        token: {
            get() {
                return _.get(this.settings, "telegrambot.token", null);
            },
            async set(value) {
                await this.setValue("telegrambot.token", value);
                this.updateTelegramToken(value);
            },
        },
    },
    methods: {
        castVote(name, event) {
            const buttonRect = event.target.getBoundingClientRect();
            const centerX = (buttonRect.left + buttonRect.width / 2) / window.innerWidth;
            const centerY = (buttonRect.top + buttonRect.height / 2 + 50) / window.innerHeight;

            this.showConfetti(centerX, centerY);
            this.showSuccessNotification(name);
        },
        showConfetti(x, y) {
            confetti({
                particleCount: 90,
                spread: 50,
                scalar: 0.8,
                origin: { x, y },
            });
        },
        showSuccessNotification(name) {
            this.$notification.success({
                message: this.$t("message.voteSuccess"),
                description: this.$t(`message.voteSuccessDescription`, { integrationName: name }),
            });
        },
        showDeleteConfirmation() {
            this.visibleDeleteToken = true;
            this.visibleDeleteToken = false;
            this.tempToken = "";
        },
        ...mapActions({
            getSettings: "setting/getSettings",
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
        }),
        createTelegramChannel() {
            this.integrateTelegramModalVisible = true;
        },
        isEmailFeatureEnabled() {
            return CONFIG.EMAIL_SERVICE_ENABLED;
        },
        isHolidayPlusEnabled() {
            return CONFIG.HOLIDAY_PLUS.enabled;
        },
        updateTelegramToken(token) {
            log("updateTelegramToken", token);
            // this.setValue("telegrambot.token", token);
            sendSocketMessage("admin settings-updated", {
                siteId: this.site._id,
            });
            setTimeout(() => {
                sendSocketMessage("telegram subscribe", {
                    siteId: this.site._id,
                });
            }, 500);
        },
        deleteTelegramToken() {
            this.setValue("telegrambot.token", null);
        },
        handleOk() {
            if (!!this.tempToken && !!this.tempToken.length) {
                this.showWarning = false;
                this.setValue("telegrambot.token", this.tempToken);
            } else {
                this.showWarning = true;
            }
            this.integrateTelegramModalVisible = false;
            sendSocketMessage("user settings-updated", {
                siteId: this.site._id,
            });
        },
        handleCancel() {
            this.integrateTelegramModalVisible = false;
            this.tempToken = this.token;
        },
        onTelegramTokenChange(e) {
            console.log("onTelegramTokenChange", e.target.value);
            this.tempToken = e.target.value;
            this.showWarning = false;
        },
        confirmDeleteToken() {
            this.deleteTelegramToken();
            this.visibleDeleteToken = false;
            this.integrateTelegramModalVisible = false;
        },
        cancelDeleteToken() {
            this.tempToken = this.token;
            this.visibleDeleteToken = false;
        },
        async setValue(key, value) {
            const newSettings = this.setSettingValue({
                setting: key,
                value,
            });

            if (newSettings.then) {
                return newSettings.then((x) => this.handleSaveSetting(x));
            } else {
                return this.handleSaveSetting(newSettings);
            }
        },
        istWhatsappV2() {
            return CONFIG.WHATSAPP_V2;
        },
        scrollToGroup(groupId) {
            const element = document.getElementById(groupId);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
                this.activeGroup = groupId;
            }
        },
        handleScroll() {
            const groups = this.integrationGroups.map((g) => document.getElementById(g.id));
            const scrollPosition = window.scrollY + 100;

            for (let i = groups.length - 1; i >= 0; i--) {
                if (groups[i] && groups[i].offsetTop <= scrollPosition) {
                    this.activeGroup = this.integrationGroups[i].id;
                    break;
                }
            }
        },
        openWhatsappComparison(event) {
            event.stopPropagation();
            this.whatsappComparisonModalVisible = true;
        },
        showSlackIntegration() {
            this.slackIntegrationModalVisible = true;
        },
        showPushoverIntegration() {
            this.pushoverIntegrationModalVisible = true;
        },
    },
    mounted() {
        if (!!this.token) this.tempToken = this.token;
        const query = this.$route.query;
        if (query.showModal && query.showModal === "true") {
            this.integrateTelegramModalVisible = true;
        }
        window.addEventListener("scroll", _.throttle(this.handleScroll, 100));
    },
    beforeMount() {
        if (this.checkPermission(PERMISSION_TYPES["integrations.view"].tr.name) === false) {
            return router.push("/denied");
        }
    },
    watch: {
        token(newVal, oldVal) {
            if (!!newVal && !!newVal.length > 0) {
                if (!oldVal) {
                    this.tempToken = newVal;
                }
            }
        },
        tempToken(newVal) {
            if (newVal === "") {
                this.visibleDeleteToken = true;
            }
            if (newVal) {
                if (newVal.length > 0) {
                    this.isThereTempToken = true;
                } else {
                    this.isThereTempToken = false;
                }
            }
        },
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
};
</script>

<style lang="scss" scoped>
#page-integrations {
    overflow: scroll;

    .big-title {
        font-weight: bold;
        font-size: 1.5rem;
        margin: 1rem 0;
    }

    .stories {
        display: flex;
        align-items: flex-start;
        padding-bottom: 1rem;
        flex-wrap: wrap;
        gap: 1.5rem;

        .story {
            position: relative;
            background: #fff;
            border-radius: 12px;
            padding: 24px;
            cursor: pointer;
            transition: all 0.3s ease;
            width: 320px;
            min-width: 300px;
            max-width: 300px;
            height: 260px;
            box-shadow: 0 2px 20px rgba(0, 0, 0, 0.05);
            border: 1px solid #e8eef3;
            display: flex;
            flex-direction: column;

            .status {
                background-color: #f5f8fb;
                border: 1px solid #dbe1e8;
                border-radius: 8px;
                color: #919ead;
                font-size: 12px;
                font-weight: 600;
                padding: 6px 10px;
                position: absolute;
                right: 16px;
                top: 16px;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 4px;

                .material-icons {
                    font-size: 16px;
                }
            }

            &.voting {
                background: #f8f9fa;

                &:after {
                    background: #008aff;
                    border-radius: 8px;
                    color: #fff;
                    content: "VOTING";
                    font-size: 13px;
                    font-weight: 600;
                    padding: 6px 12px;
                    position: absolute;
                    right: 16px;
                    top: 16px;
                }
            }

            &:hover {
                transform: translateY(-4px);
                box-shadow: 0 4px 25px rgba(0, 0, 0, 0.1);
                border-color: #008aff;

                .img:after {
                    transform: rotate(45deg) translate(-20%, -150%);
                    transition: all 0.4s;
                }
            }

                &.disabled-integration {
                pointer-events: none;
                user-select: none;
                position: relative;
                
                // İçerik elemanlarını gri yap
                > *:not(.dead-badge) {
                    opacity: 0.7;
                    filter: grayscale(100%);
                }

                .dead-badge {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%) rotate(-15deg);
                    background-color: #f44336;
                    color: white;
                    padding: 0.5rem 1rem;
                    font-weight: bold;
                    font-size: 1.5rem;
                    border-radius: 8px;
                    z-index: 100;
                    border: 2px solid white;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.2);
                    text-transform: uppercase;
                    letter-spacing: 2px;
                }
            }

            &.whatsapp-story {
                    &:hover {
                        .compare-button {
                            opacity: 1;
                            visibility: visible;
                        }
                    }
                }

                &.instagram-v2-story {
                    @keyframes pulse {
                        0%, 100% {
                            transform: scale(1);
                        }
                        50% {
                            transform: scale(1.05);
                        }
                    }
                }

            .compare-button {
                position: absolute;
                top: 16px;
                right: 16px;
                background: #25d366;
                color: white;
                border: none;
                border-radius: 20px;
                padding: 8px 12px;
                font-size: 12px;
                font-weight: 600;
                display: flex;
                align-items: center;
                gap: 4px;
                cursor: pointer;
                opacity: 0;
                visibility: hidden;
                transition: all 0.3s ease;
                z-index: 10;

                &:hover {
                    background: #128c7e;
                    transform: scale(1.05);
                }

                .material-icons {
                    font-size: 16px;
                }
            }

            .title {
                margin: 16px 0 12px;
                font-weight: 600;
                font-size: 18px;
                color: #2c3e50;
            }

            .description {
                font-size: 14px;
                color: lightslategrey;
                line-height: 1.4;
                margin-bottom: 12px;
                display: block;
                max-height: 4.5em;
                position: relative;
            }

            .img {
                width: 80px;
                height: 80px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 12px;
                overflow: hidden;
                position: relative;

                &.webhooks {
                    background: #7159c2;
                }

                &.postacell,
                &.ticimax,
                &.holidayplus {
                    width: 200px;
                }

                &.ideasoft {
                    width: 200px;
                }

                &.supsis {
                    background: #e8eef3;
                }

                &.openai {
                    background: #a2cbed;
                }

                &.whatsapp {
                    background: #58ca64;
                }

                &.linkedin {
                    background: #e2e5ff;
                }

                &.retell {
                    background: #673ab7;

                    .material-icons {
                        color: #fff;
                    }
                }

                &.webphone {
                    background: #f5f5f5;

                    .material-icons {
                        font-size: 40px;
                    }
                }

                &.telnyx {
                    background: #f0f8ff;

                    img {
                        object-fit: contain;
                    }
                }

                &.netgsm {
                    background: #f5f5f5;

                    img {
                        object-fit: contain;
                    }
                }

                &.instagram {
                    background: radial-gradient(
                        circle at 30% 107%,
                        #fdf497 0%,
                        #fdf497 5%,
                        #fd5949 45%,
                        #d6249f 60%,
                        #285aeb 90%
                    );
                }

                &.youtube {
                    background: #fff;
                    svg {
                        width: 60px;
                        height: 60px;
                    }
                }

                &.google-business {
                    background: #fff;
                    svg {
                        width: 60px;
                        height: 60px;
                    }
                }

                &.telegram {
                    background: #29b6f6;
                }

                &.twitter {
                    background: #3ecdfb;
                }

                &.slack {
                    background: #4A154B;
                }

                &.pushover {
                    background: #4A90D9;
                }

                &.mail {
                    justify-content: unset !important;

                    svg {
                        width: 100%;
                        height: 100%;
                    }
                }

                &.facebook,
                &.skype,
                &.shopify {
                    background: #ffffff;
                }

                &.teamgram svg {
                    width: 100%;
                }

                &.webtabs {
                    background: #e3f2fd;

                    .material-icons {
                        color: #1976d2;
                        font-size: 32px;
                    }
                }

                &.webapps {
                    background: #e8f5e9;

                    .material-icons {
                        color: #4caf50;
                        font-size: 32px;
                    }
                }

                &.cache {
                    background: #e3f2fd;

                    .material-icons {
                        color: #1976d2;
                        font-size: 32px;
                    }
                }

                &.retell {
                    background: #673ab7;
                }

                &.ai-provider {
                    background: #f8fafc;
                    border: 1px solid #e2e8f0;

                    img {
                        width: 50px;
                        height: 50px;
                        object-fit: contain;
                    }
                }

                svg {
                    width: 65%;
                }

                &:after {
                    background: #fff;
                    bottom: 0;
                    content: "";
                    height: 100%;
                    left: -10%;
                    opacity: 0.3;
                    position: absolute;
                    top: 0;
                    transform: rotate(45deg) translate(-20%, 150%);
                    width: 160%;
                }
            }

            > div:last-child {
                color: #64748b;
                font-size: 14px;
                line-height: 1.5;
                margin-top: auto;
            }
        }
    }
}

.star-v2 {
    position: absolute !important;
    top: 0px !important;
    right: 0px !important;
    color: yellow !important;
}

.integration-group {
    margin-bottom: 2rem;
    padding: 1rem;

    h3 {
        font-size: 1.2rem;
        font-weight: bold;
        margin-bottom: 1rem;
    }
}

.integration-nav {
    position: sticky;
    top: 45px;
    z-index: 100;
    background: white;
    //box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 0.5rem 1rem;
    margin-bottom: 1rem;
    display: flex;
    justify-content: space-between;

    .nav-items {
        display: flex;
        gap: 1rem;
        overflow-x: auto;
        padding: 0.5rem;
        -ms-overflow-style: none;
        scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .nav-item {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.5rem 1rem;
        border-radius: 20px;
        white-space: nowrap;
        transition: all 0.3s ease;
        color: #666;
        text-decoration: none;

        .material-icons {
            font-size: 20px;
        }

        &:hover {
            background: #f5f5f5;
        }

        &.active {
            background: #f0f0f0;
            font-weight: 600;
            color: #333;
        }
    }
}

.integration-group {
    scroll-margin-top: 100px;
}

.whatsapp-comparison-modal {
    .ant-modal-body {
        padding: 0px !important;
        max-height: 85vh;
        overflow: hidden;
    }
    .ant-modal-content {
        height: 90vh !important;
    }
}
</style>
